
import agent from "./agent"; //商户跟单
// 模版化router配置
const arr = [
  ...agent,
];
let templateRouters = [];
arr.forEach((item) => {
  if (!item.meta) {
    item.meta = {};
  }
  templateRouters.push(item.path);
  item.meta.mustLogin = true;
});
export default arr;
